function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useApi } from '@deephaven/jsapi-bootstrap';
import { IrisGridModel, IrisGridModelFactory } from '@deephaven/iris-grid';
import { useCallback, useEffect, useMemo, useState } from 'react';
/** Pass in a table `fetch` function, will load the model and handle any errors */
export function useIrisGridModel(fetch, transformModel) {
  var dh = useApi();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    model = _useState2[0],
    setModel = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var makeModel = useCallback(/*#__PURE__*/_asyncToGenerator(function* () {
    var table = yield fetch();
    var newModel = yield IrisGridModelFactory.makeModel(dh, table);
    if (transformModel == null) {
      return newModel;
    }
    try {
      var transformedModel = yield transformModel(newModel);
      return transformedModel;
    } catch (e) {
      // The host owns the base model's lifecycle; if the transform rejects it
      // never returns a model for us to close, so close the base model here to
      // avoid leaking it.
      newModel.close();
      throw e;
    }
  }), [dh, fetch, transformModel]);
  var reload = useCallback(/*#__PURE__*/_asyncToGenerator(function* () {
    setIsLoading(true);
    setError(undefined);
    try {
      var newModel = yield makeModel();
      setModel(newModel);
      setIsLoading(false);
    } catch (e) {
      setError(e);
      setIsLoading(false);
    }
  }), [makeModel]);
  useEffect(() => {
    var cancelled = false;
    function init() {
      return _init.apply(this, arguments);
    }
    function _init() {
      _init = _asyncToGenerator(function* () {
        setIsLoading(true);
        setError(undefined);
        try {
          var newModel = yield makeModel();
          if (!cancelled) {
            setModel(newModel);
            setIsLoading(false);
          }
        } catch (e) {
          if (!cancelled) {
            setError(e);
            setIsLoading(false);
          }
        }
      });
      return _init.apply(this, arguments);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, [makeModel]);
  useEffect(function startListeningModel() {
    if (!model) {
      return;
    }

    // If the table inside a widget is disconnected, then don't bother trying to listen to reconnect, just close it and show a message
    // Widget closes the table already when it is disconnected, so no need to close it again
    function handleDisconnect() {
      setError(new Error('Table disconnected'));
      setModel(undefined);
      setIsLoading(false);
    }
    model.addEventListener(IrisGridModel.EVENT.DISCONNECT, handleDisconnect);
    return () => {
      model.removeEventListener(IrisGridModel.EVENT.DISCONNECT, handleDisconnect);
    };
  }, [model]);
  var result = useMemo(() => {
    if (isLoading) {
      return {
        reload,
        status: 'loading'
      };
    }
    if (error != null) {
      return {
        error,
        reload,
        status: 'error'
      };
    }
    if (model != null) {
      return {
        model,
        reload,
        status: 'success'
      };
    }
    throw new Error('Invalid state');
  }, [error, isLoading, model, reload]);
  return result;
}
//# sourceMappingURL=useIrisGridModel.js.map